import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative w-full min-h-[620px] md:min-h-[750px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20enterprise%20background%20with%20deep%20charcoal%20tones%20and%20subtle%20warm%20amber%20light%20gradients%2C%20modern%20corporate%20technology%20aesthetic%2C%20sophisticated%20network%20node%20patterns%2C%20no%20text%2C%20cinematic%20quality%2C%20professional%20financial%20industry%20atmosphere%20with%20muted%20green%20highlights&width=1600&height=900&seq=hero-2026-overhaul&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/65 to-foreground-950/40" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 md:pt-28 pb-16 md:pb-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/12 border border-accent-500/25 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400" />
            <span className="text-xs md:text-sm font-semibold text-accent-400 tracking-wide">
              {heroData.badge}
            </span>
          </div>

          <h1 className="font-heading font-bold text-2xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-5 text-balance">
            {heroData.headline}
          </h1>

          <p className="text-sm md:text-lg text-background-300 leading-relaxed mb-8 max-w-xl">
            {heroData.subheadline}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <button
              onClick={() => handleNavClick("#contact")}
              className="px-6 py-3.5 text-sm font-semibold rounded-md bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-colors whitespace-nowrap text-center cursor-pointer shadow-lg shadow-accent-500/20"
            >
              {heroData.ctaPrimary}
            </button>
            <button
              onClick={() => handleNavClick("#services")}
              className="px-6 py-3.5 text-sm font-semibold rounded-md border border-background-300/50 text-background-50 hover:bg-background-50/8 transition-colors whitespace-nowrap text-center cursor-pointer"
            >
              {heroData.ctaSecondary}
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 hidden md:block">
        <button
          onClick={() => handleNavClick("#about")}
          className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300/40 text-background-300 hover:text-background-50 hover:border-background-50/50 transition-all cursor-pointer animate-bounce"
          aria-label="Scroll to content"
        >
          <i className="ri-arrow-down-line text-lg" />
        </button>
      </div>
    </section>
  );
}